import { defineComponent as _defineComponent } from 'vue'
import { useCurrentRoute } from '@/ui/routes';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterForm',
  setup(__props) {

  const currentRoute = useCurrentRoute();
  const tab = currentRoute.value?.query?.tab as string|undefined;

return { __sfc: true,currentRoute, tab }
}

})